import React, { useEffect } from 'react'

const MarketStatusIndicator = () => {
  useEffect(() => {
    let intervalId = setInterval(() => {
      try {
        let targetElement = document.getElementById('marketStatus')
        let currentTime = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/New_York',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        }).format()
        if (targetElement) {
          targetElement.innerText = `${currentTime} EST`
        }
      } catch (error) { }
    }, 1000)

    return () => clearInterval(intervalId)
  }, [])

  return <div className="market-status" id="marketStatus"></div>
}

export default React.memo(MarketStatusIndicator)
